<div class="compact-card" [style.background-color]="resolvedTableBackgroundColor">
  <div class="image-section">
    <div class="image-container">
      @if (itemImage) {
        <gb-image [image]="itemImage" [cover]="imageCover"></gb-image>
      } @else {
        <div class="image-placeholder"></div>
      }
    </div>
  </div>

  <div class="details-section" [style.font-size.cqw]="fontSize" [style.color]="backgroundContrastColor">
    <div class="meta-row">
      <div class="item-code">{{ item.alias }}</div>
      @if (itemTableWidget.show_item_type) {
        <div class="item-type gb-truncate">{{ itemTypeTranslateKey | translate }}</div>
      }
    </div>

    @let itemNameMaxLines = itemTableWidget.item_name_max_lines ?? 2;
    <div
      class="item-name"
      [style.-webkit-line-clamp]="itemNameMaxLines"
      [style.display]="'-webkit-box'"
      [style.-webkit-box-orient]="'vertical'"
      [style.white-space]="'normal'"
    >
      {{ item.name }}
    </div>
  </div>

  <div
    class="footer-section"
    [style.background-color]="resolvedTablePrimaryColor"
    [style.color]="primaryContrastColor"
    [style.font-size.cqw]="fontSize"
  >
    @if (item.item_type === ItemTypeEnum.Bidding) {
      @if (biddingSoldOut) {
        <span>
          {{ 'PRESENTER.ITEM_TABLE_CARD_COMPACT.SOLD_OUT' | translate }}
        </span>
      } @else {
        @if (hasWinningBids) {
          <div class="footer-row">
            <span>{{ highestBidderName }}</span>
            <span>{{ highestBidAmount | gbCurrency }}</span>
          </div>
        } @else {
          <div class="footer-row">
            <span>
              {{ 'PRESENTER.ITEM_TABLE_CARD_COMPACT.STARTING_BID' | translate }}
            </span>
            <span>{{ item.bidding_item?.starting_price | gbCurrency }}</span>
          </div>
        }
      }
    }

    @if (item.item_type === ItemTypeEnum.Raffle) {
      <div class="footer-row">
        <span>
          {{ 'PRESENTER.ITEM_TABLE_CARD_COMPACT.TICKETS_REMAINING' | translate }}
        </span>
        <span>{{ ticketsRemaining }}</span>
      </div>
    }

    @if (item.item_type === ItemTypeEnum.Donation) {
      <div class="footer-row">
        <span>{{ 'PRESENTER.ITEM_TABLE_CARD_COMPACT.RAISED' | translate }}</span>
        <span>{{ donationRaised | gbCurrency }}</span>
      </div>
    }

    @if (item.item_type === ItemTypeEnum.Purchase) {
      <div class="footer-row">
        <span>
          {{ 'PRESENTER.ITEM_TABLE_CARD_COMPACT.REMAINING' | translate }}
        </span>
        <span>{{ item.purchase_item?.units_remaining }}</span>
      </div>
    }
  </div>
</div>
